<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="project_name"
                                       label="Project name"
                                       size="4"
                                       :isFocus="true"
                                       v-model:field="search.project_name" />

                        <FormMultiselect fieldName="status_id"
                                         label="Status"
                                         size="4"
                                         :options="select?.statuses"
                                         v-model:field="search.status_id" />

                        <FormMultiselect fieldName="contractor_id"
                                         label="Contractor"
                                         size="4"
                                         :options="select?.contractors"
                                         v-model:field="search.contractor_id" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="agreement_id"
                                         label="Agreement"
                                         size="4"
                                         :options="select?.agreements"
                                         v-model:field="search.agreement_id" />

                        <FormMultiselect fieldName="manager_id"
                                         label="Manager"
                                         size="4"
                                         :options="select?.users"
                                         v-model:field="search.manager_id" />

                        <FormMultiselect fieldName="project_users"
                                         label="Users"
                                         size="4"
                                         :options="select?.users"
                                         v-model:field="search.project_users" />
                    </div>
                    <div class="grid">

                        <FormCalendar fieldName="start_date_from"
                                      label="Start date from"
                                      size="3"
                                      v-model:field="search.start_date_from" />

                        <FormCalendar fieldName="start_date_to"
                                      label="Start date to"
                                      size="3"
                                      v-model:field="search.start_date_to" />

                        <FormCalendar fieldName="end_date_from"
                                      label="End date from"
                                      size="3"
                                      v-model:field="search.end_date_from" />

                        <FormCalendar fieldName="end_date_to"
                                      label="End date to"
                                      size="3"
                                      v-model:field="search.end_date_to" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})

const options = ["statuses", "opportunities", "contractors", "users"];
const select = ref(null);

prepareSearch(search, props, options, select)

</script>

<style lang="scss" scoped></style>
